import {
  ThemeProvider
} from '@mui/material/styles';
import {
  SnackbarProvider,
  useSnackbar
} from 'notistack';
import {
  createRoot
} from 'react-dom/client';
import {
  HashRouter
} from 'react-router-dom';
import './assets/scripts/global';
import './assets/styles/__imports.css';
import GlobalComponents from './components/Home/GlobalComponents';
import Theme from './components/Layout/Libraries/Theme.lib';
import Box from './components/Layout/Wrappers/Box';
import {
  LoadingMessage
} from './components/Layout/Wrappers/Message';
import './i18n/i18n.tool';
import {
  NOT
} from './lib/Boolean.lib';
import Core from './lib/Core';
import './lib/Debug.lib';
import useStart from './lib/hooks/useStart.hook';
import {
  Obj
} from './lib/Object.lib';
import {
  matchLocation,
  reloadLocation,
  setLocation
} from './lib/URL.lib';
import AdminUser from './routes/Admin.routes';
import CommonUser from './routes/CommonUser.routes';
import EmployerUser from './routes/Employer.routes';
import Error from './routes/Error';
import RecruiterOnDev from './routes/RecruiterOnDev.routes';
import Unlogged from './routes/Unlogged.routes';

export const KEY__CONTROLLER__APP = 'controller__app_with_snackbar';
export const getControllerAppWithSnackbar = () => {
  return Obj(Core.getKeyValue(KEY__CONTROLLER__APP));
}
export const setControllerAppWithSnackbar = (controller) => {
  return Core.setKeyValue(KEY__CONTROLLER__APP, controller);
}

function App(props) {
  const { busy, error, ready } = useStart();
  setTimeout(() => {
    if (Core.isLoggedOut() && NOT(matchLocation(/login|reset|jwt/i))) {
      setLocation('/login');
      reloadLocation();
    }
  });
  /**
   * @note
   * The ThemeProvider and HashRouter
   * must wrap all rendered elements
   * in order to work properly.
   */
  return (
    <ThemeProvider theme={Theme}>
      <HashRouter>
        <Box role='Main' className="vh-100 vw-100">
          <LoadingMessage show={busy}
            className='vh-100 vw-100 m-0 flex-align-center bg-cyan-lighter'
          >
            Starting...
          </LoadingMessage>
          <Error error={error} />
          <GlobalComponents />
          {ready &&
            <Box role='Content' className='vh-100 vw-100'>
              {
                Core.isLoggedOut() ? (
                  <Unlogged />
                ) : Core.isAdmin() ? (
                  <AdminUser />
                ) : Core.isEmployer() ? (
                  <EmployerUser />
                ) : Core.isRecruiterOnDev() ? (
                  <RecruiterOnDev />
                ) : (
                  <CommonUser />
                )
              }
            </Box>
          }
        </Box>
      </HashRouter>
    </ThemeProvider>
  );
};

function AppWithSnackbar() {
  const { enqueueSnackbar } = useSnackbar();
  setControllerAppWithSnackbar({
    enqueueSnackbar  // enqueueSnackbar(message, { variant: 'success'})
  });
  return <App enqueueSnackbar={enqueueSnackbar} />;
}

createRoot(document.getElementById('Root')).render(
  <SnackbarProvider maxSnack={3}>
    <AppWithSnackbar />
  </SnackbarProvider>
);
